import React from 'react';
import {
  RemoveBoxIcon,
  RemoveLidIcon,
  RemovePlantIcon,
  RemoveSnailIcon,
  RemoveSolutionIcon,
} from '../../../Icons';
import {hasItem} from '../GlassTube.utils';

export function useGlassTubeTooltip(props) {
  function removeOnClick(params) {
    return function () {
      props.onRemoveItem(params);
    };
  }

  function getButtonList() {
    let buttonList = [];
    if (hasItem(props.boxId)) {
      buttonList.push({
        onClick: removeOnClick({boxId: props.boxId}),
        altText: 'Remove box',
        image: RemoveBoxIcon,
      });
    } else {
      if (!hasItem(props.stopperId)) {
        if (hasItem(props.plantId)) {
          buttonList.push({
            onClick: removeOnClick({plantId: props.plantId}),
            altText: 'Remove plant',
            image: RemovePlantIcon,
          });
        }
        if (hasItem(props.snailId)) {
          buttonList.push({
            onClick: removeOnClick({snailId: props.snailId}),
            altText: 'Remove snail',
            image: RemoveSnailIcon,
          });
        }
        // if (
        //   !hasItem(props.snailId) &&
        //   !hasItem(props.plantId) &&
        //   props.solution
        // ) {
        //   buttonList.push({
        //     onClick: removeOnClick({solution: props.plantId}),
        //     image: RemoveSolutionIcon,
        //   });
        // }
      } else {
        buttonList.push({
          onClick: removeOnClick({stopperId: props.stopperId}),
          altText: 'Remove stopper',
          image: RemoveLidIcon,
        });
      }
    }
    return buttonList;
  }

  return {getButtonList};
}
